const carousel1 = document.querySelector('#firstCollectionDesktop');
const carousel2 = document.querySelector('#secondCollectionDesktop');

if (
  carousel1 &&
  window.Flickity &&
  !Flickity.data(carousel1)
) {
  new Flickity(carousel1, { 
    cellAlign: 'left',
    contain: true
  });
}


if (
  carousel2 &&
  window.Flickity &&
  !Flickity.data(carousel2)
) {
  new Flickity(carousel2, {
    cellAlign: 'left',
    contain: true
  });
}